//************************************
// ドロワー
//************************************
document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.getElementById('js-hamburger');
  const reDrawerBg = document.getElementById('js-re-drawer-bg');
  const reDrawerBgClose = document.getElementById('re-drawer-bg__close');
  const reDrawer = document.getElementById('js-re-drawer');

  hamburger.addEventListener('click', function () {
    if (reDrawerBg.classList.contains('isActive')) {
      reDrawerBg.classList.remove('isActive');
    } else {
      reDrawerBg.classList.add('isActive');
    };
    if (reDrawer.classList.contains('isActive')) {
      reDrawer.classList.remove('isActive');
    } else {
      reDrawer.classList.add('isActive');
    }
  });

  reDrawerBg.addEventListener('click', function () {
    if (reDrawerBg.classList.contains('isActive')) {
      reDrawerBg.classList.remove('isActive');
    } else {
      reDrawerBg.classList.add('isActive');
    };
    if (reDrawer.classList.contains('isActive')) {
      reDrawer.classList.remove('isActive');
    } else {
      reDrawer.classList.add('isActive');
    }
  });
});

//************************************
// ファーストビュー
//************************************
document.addEventListener('DOMContentLoaded', function () {
  const selector = document.querySelector("#re-fv");
  if (!selector) {
    return
  }

  const options = {
    type: "loop",
    mediaQuery: 'min',
    perMove: 1,
    focus: 'center',
    autoplay: true,
    breakpoints: {
      750: {
        gap: 32,
      }
    }
  }
  const mySplide = new Splide(selector, options);
  mySplide.mount();
});

//************************************
// アコーディオン
//************************************
// ページ読み込み後に実行
document.addEventListener('DOMContentLoaded', () => {
  // アコーディオンボタンの要素を取得
  const accordionButtons = document.querySelectorAll('.js-accordion-button');

  // 各アコーディオンボタンに対してクリックイベントを設定
  accordionButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      // クリックされたボタンの親要素からjs-accordion-targetを取得
      const target = this.parentNode.querySelector('.js-accordion-target');

      // ボタンのクラス名をトグル
      this.classList.toggle('isActive');

      // ターゲット要素のクラス名をトグル
      target.classList.toggle('isActive');

      // ——— ここから追加 ———
      const parentId = this.parentNode.id;
      if (this.classList.contains('isActive') && parentId) {
        // 開いた項目の id をハッシュに設定
        history.replaceState(null, '', `#${parentId}`);
      } else {
        // すべて閉じたらハッシュをクリア
        history.replaceState(
          null,
          '',
          window.location.pathname + window.location.search
        );
      }
      // ——— ここまで追加 ———
    });
  });
  const hash = window.location.hash.slice(1);   // 先頭の「#」を除去
  if (!hash) return;

  const item = document.getElementById(hash);
  if (!item) return;

  const btn    = item.querySelector('.js-accordion-button');
  const target = item.querySelector('.js-accordion-target');
  if (btn && target) {
    btn.classList.add('isActive');
    target.classList.add('isActive');
    // スクロールさせたい場合
    item.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});


//************************************
// 商品スライダー
//************************************

document.addEventListener('DOMContentLoaded', function () {
  const target = '#re-product-media-gallery';
  const options = {
    type: "loop"
  }

  if (!document.querySelector(target)) {
    return
  }

  const mySplide = new Splide(target, options);

  mySplide.mount();
});

//************************************
// ブログ目次のアコーディオン
//************************************
const tocButtonSelector = document.getElementById('js-re-toc-button')
tocButtonSelector && tocButtonSelector.addEventListener('click', function () {
  const targetElement = document.getElementById('js-re-toc-target');

  if (targetElement.classList.contains('isActive')) {
    targetElement.classList.remove('isActive');
  } else {
    targetElement.classList.add('isActive');
  }
});


//************************************
// お問い合わせフォーム　メール確認チェック
//************************************

// function error() {
//   const email = document.getElementById('ContactForm-email').value;
//       const emailConfirm = document.getElementById('ContactForm-email-confirm').value;
//       const errorMessage = document.getElementById('errorMessage');
//       console.log("ここまでできてる");

//       if (email !== emailConfirm) {
//         errorMessage.classList.remove('display-none');
//       } else {
//         errorMessage.classList.add('display-none');
//       }

// }


//************************************
// 商品画像の拡大のための縦横取得
//************************************
// document.addEventListener('DOMContentLoaded', function() {
//   // クラス名 'modal__image' を持つ全ての要素を取得
//   var elements = document.querySelectorAll('.modal__image');


//   // 画面の横幅と縦幅を取得
//   var width = window.innerWidth;
//   var height = window.innerHeight;

//   // 横幅と縦幅を比較し、それぞれの要素に適切なクラスを付与
//   elements.forEach(function(element) {
//       if (width > height) {
//           // 横幅が大きい場合、パターンAのクラスを付与
//           element.classList.add('width100');
//       } else {
//           // 縦幅が大きい場合、パターンBのクラスを付与
//           element.classList.add('height100');
//       }
//   });
// });
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.splide__slide').forEach(function (slide) {
    slide.addEventListener('click', function () {
      var imgSrc = this.querySelector('img').src;
      var newImg = new Image();

      newImg.onload = function () {
        const isLandscape = window.innerWidth > window.innerHeight
        document.querySelectorAll('.modal__image').forEach(function (modalImg) {
          const width = modalImg.naturalWidth
          const height = modalImg.naturalHeight
          // 縦横比を比較し、適切なクラスを適用
          if (height === width) {
            modalImg.classList.add('heightWidth100');
            modalImg.classList.remove('height100');
            modalImg.classList.remove('width100');
            return
          }

          if (isLandscape) {
            if (width > height) {
              modalImg.classList.add('width100');
              modalImg.classList.remove('height100');
              modalImg.classList.remove('heightWidth100');
            } else {
              modalImg.classList.add('height100');
              modalImg.classList.remove('width100');
              modalImg.classList.remove('heightWidth100');
            }
          } else {
            modalImg.classList.add('width100');
            modalImg.classList.remove('height100');
            modalImg.classList.remove('heightWidth100');
          }
        });
      };

      newImg.src = imgSrc;  // 画像のソースを設定し、ロードを開始
    });
  });
});
